import "./index.css";
import { Audience } from "./components/site/Audience";
import { CourseMapSection } from "./components/site/CourseMapSection";
import { Dawn } from "./components/site/day";
import { Faq } from "./components/site/Faq";
import { FinalCta, Footer } from "./components/site/Footer";
import { Hero } from "./components/site/Hero";
import { Journey } from "./components/site/Journey";
import { LessonBeat } from "./components/site/LessonBeat";
import { Nav } from "./components/site/Nav";
import { Pricing } from "./components/site/Pricing";
import { Research } from "./components/site/Research";
import { Sky } from "./components/site/Sky";
import { Tutor } from "./components/site/Tutor";

export function App() {
  return (
    <>
      <Sky />
      <Nav />
      <main>
        <Hero />
        <Dawn />
        <Journey />
        <LessonBeat />
        <Tutor />
        <CourseMapSection />
        <Research />
        <Audience />
        <Pricing />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}

export default App;
